import { useState } from 'react'
import { formsService } from '../services/cmsService.js'

export default function BookingModal({ isOpen, onClose, experience = '' }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    country: '',
    safariPackages: experience ? [experience] : [],
    adventureActivities: [],
    travelServices: [],
    startDate: '',
    endDate: '',
    guests: '1',
    accommodation: '',
    budget: '',
    message: ''
  })

  const safariPackages = [
    { value: '17-days-ultimate-safari', label: '17 Days Ultimate Uganda Safari' },
    { value: '12-days-wildlife-safari', label: '12 Days Uganda Wildlife Safari Tour' },
    { value: '10-days-birding-safari', label: '10 Days Uganda Birding Safari' },
    { value: '8-days-highlights-safari', label: '8 Days Uganda Safari Highlights' },
    { value: '7-days-gorilla-chimp-safari', label: '7 Days Gorilla & Chimpanzee Safari' },
    { value: '5-days-gorillas-lions', label: '5 Day Gorillas and Lions Tour' },
    { value: '3-days-kibale-chimp-cultural', label: '3 Days Chimpanzee & Cultural Safari - Kibale' },
    { value: '3-days-murchison-chimp', label: '4 Days Murchison Falls Safari & Chimpanzee Tracking' },
    { value: 'queen-elizabeth-safari', label: '3 Days Safari to Queen Elizabeth National Park' },
    { value: 'kidepo-valley-safari', label: '4 Days Safari to Kidepo Valley National Park' },
    { value: 'lake-mburo-safari', label: '3 Days Safari to Lake Mburo National Park' },
    { value: 'rwenzori-mountains-trek', label: '8 Days Rwenzori Mountains Margherita Peak Trek' },
    { value: 'bwindi-gorilla-trekking', label: '3 Days Safari to Bwindi Impenetrable National Park' },
    { value: 'kibale-chimp-tracking', label: '3 Days Safari to Kibale National Park' },
    { value: 'custom-package', label: 'Custom Safari Package' }
  ]

  const adventureActivities = [
    { value: 'gorilla-trekking', label: 'Gorilla Trekking (Bwindi/Mgahinga)' },
    { value: 'chimp-tracking', label: 'Chimpanzee Tracking (Kibale/Budongo)' },
    { value: 'chimp-habituation', label: 'Chimpanzee Habituation Experience' },
    { value: 'bungee-jumping', label: 'Bungee Jumping Over the Nile' },
    { value: 'white-water-rafting', label: 'White Water Rafting' },
    { value: 'kayaking', label: 'Kayaking on the Nile' },
    { value: 'mountain-biking', label: 'Mountain Biking (Jinja/Lake Mburo)' },
    { value: 'quad-biking', label: 'Quad Biking' },
    { value: 'horseback-safari', label: 'Horseback Safari (Lake Mburo)' },
    { value: 'walking-safari', label: 'Walking Safari' },
    { value: 'boat-safari', label: 'Boat Safari (Kazinga/Murchison/Lake Mburo)' },
    { value: 'birdwatching', label: 'Specialized Birdwatching Tours' },
    { value: 'cultural-encounters', label: 'Cultural Encounters (Batwa/Karamojong)' },
    { value: 'nature-walks', label: 'Guided Nature Walks' },
    { value: 'sunset-cruise', label: 'Sunset Cruise (Jinja)' },
    { value: 'source-of-nile', label: 'Source of the Nile Tour' },
    { value: 'zip-lining', label: 'Zip Lining (Mabira Forest)' }
  ]

  const travelServices = [
    { value: 'car-hire', label: 'Car Hire (4x4 Safari Vehicle)' },
    { value: 'airport-transfer', label: 'Airport Transfers (Entebbe/Kigali)' },
    { value: 'accommodation-booking', label: 'Accommodation Booking' },
    { value: 'permit-booking', label: 'Gorilla/Chimp Permit Booking' },
    { value: 'visa-assistance', label: 'Visa Assistance' },
    { value: 'travel-insurance', label: 'Travel Insurance Arrangement' },
    { value: 'flight-booking', label: 'Domestic Flight Booking' },
    { value: 'private-guide', label: 'Private Tour Guide' },
    { value: 'photography-guide', label: 'Professional Photography Guide' },
    { value: 'porter-hire', label: 'Porter Hire for Trekking' }
  ]

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      // Submit to Payload CMS API
      console.log('Submitting booking inquiry to Payload CMS:', formData)

      await formsService.submitBooking(formData)

      console.log('Booking inquiry submitted successfully')
      alert('Thank you for your inquiry! We will contact you shortly with a customized quote.')
      onClose()

      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        country: '',
        safariPackages: [],
        adventureActivities: [],
        travelServices: [],
        startDate: '',
        endDate: '',
        guests: '1',
        accommodation: '',
        budget: '',
        message: ''
      })
    } catch (error) {
      console.error('Error submitting booking inquiry:', error)

      // Fallback to Netlify Forms if Payload CMS is unavailable
      try {
        const formPayload = new URLSearchParams()
        formPayload.append('form-name', 'booking-inquiry')
        formPayload.append('bot-field', '')
        formPayload.append('name', formData.name)
        formPayload.append('email', formData.email)
        formPayload.append('phone', formData.phone)
        formPayload.append('country', formData.country)
        formPayload.append('safariPackages', formData.safariPackages.join(', ') || 'None selected')
        formPayload.append('adventureActivities', formData.adventureActivities.join(', ') || 'None selected')
        formPayload.append('travelServices', formData.travelServices.join(', ') || 'None selected')
        formPayload.append('message', formData.message || 'No additional message')

        const response = await fetch('/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: formPayload.toString(),
        })

        if (response.ok) {
          alert('Thank you for your inquiry! We will contact you shortly.')
          onClose()
        } else {
          throw new Error('Fallback submission failed')
        }
      } catch (fallbackError) {
        alert('There was an error submitting your request. Please try again or contact us directly at info@shakestravel.com')
      }
    }
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleCheckboxChange = (category, value) => {
    setFormData(prev => ({
      ...prev,
      [category]: prev[category].includes(value)
        ? prev[category].filter(item => item !== value)
        : [...prev[category], value]
    }))
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 z-10">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-3xl font-bold text-safari-green">Plan Your Uganda Adventure</h2>
              <p className="text-gray-600 mt-1">Tell us about your dream safari and we'll create a custom itinerary</p>
            </div>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-3xl leading-none"
              aria-label="Close"
            >
              &times;
            </button>
          </div>
        </div>

        <form
          onSubmit={handleSubmit}
          className="p-6 space-y-6"
        >
          {/* Personal Information */}
          <div className="bg-safari-light p-4 rounded-lg">
            <h3 className="text-xl font-bold text-safari-green mb-4">Personal Information</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold mb-2">Full Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-safari-gold focus:border-transparent"
                  placeholder="John Doe"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2">Email Address *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-safari-gold focus:border-transparent"
                  placeholder="john@example.com"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2">Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-safari-gold focus:border-transparent"
                  placeholder="+1 234 567 8900"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2">Country of Residence *</label>
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-safari-gold focus:border-transparent"
                  placeholder="United States"
                />
              </div>
            </div>
          </div>

          {/* Safari Packages */}
          <div className="bg-safari-light p-4 rounded-lg">
            <h3 className="text-xl font-bold text-safari-green mb-3">Safari Packages</h3>
            <p className="text-sm text-gray-600 mb-4">Select one or more safari packages you're interested in</p>
            <div className="grid md:grid-cols-2 gap-3 max-h-60 overflow-y-auto pr-2">
              {safariPackages.map((pkg) => (
                <label key={pkg.value} className="flex items-start gap-2 cursor-pointer hover:bg-white p-2 rounded transition">
                  <input
                    type="checkbox"
                    name="safariPackages"
                    value={pkg.value}
                    checked={formData.safariPackages.includes(pkg.value)}
                    onChange={() => handleCheckboxChange('safariPackages', pkg.value)}
                    className="mt-1 w-4 h-4 text-safari-green focus:ring-safari-gold rounded"
                  />
                  <span className="text-sm text-gray-700">{pkg.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Adventure Activities */}
          <div className="bg-safari-light p-4 rounded-lg">
            <h3 className="text-xl font-bold text-safari-green mb-3">Additional Adventure Activities</h3>
            <p className="text-sm text-gray-600 mb-4">Select any additional activities you'd like to experience</p>
            <div className="grid md:grid-cols-2 gap-3 max-h-60 overflow-y-auto pr-2">
              {adventureActivities.map((activity) => (
                <label key={activity.value} className="flex items-start gap-2 cursor-pointer hover:bg-white p-2 rounded transition">
                  <input
                    type="checkbox"
                    name="adventureActivities"
                    value={activity.value}
                    checked={formData.adventureActivities.includes(activity.value)}
                    onChange={() => handleCheckboxChange('adventureActivities', activity.value)}
                    className="mt-1 w-4 h-4 text-safari-green focus:ring-safari-gold rounded"
                  />
                  <span className="text-sm text-gray-700">{activity.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Travel Services */}
          <div className="bg-safari-light p-4 rounded-lg">
            <h3 className="text-xl font-bold text-safari-green mb-3">Additional Travel Services</h3>
            <p className="text-sm text-gray-600 mb-4">Select any additional services you need</p>
            <div className="grid md:grid-cols-2 gap-3">
              {travelServices.map((service) => (
                <label key={service.value} className="flex items-start gap-2 cursor-pointer hover:bg-white p-2 rounded transition">
                  <input
                    type="checkbox"
                    name="travelServices"
                    value={service.value}
                    checked={formData.travelServices.includes(service.value)}
                    onChange={() => handleCheckboxChange('travelServices', service.value)}
                    className="mt-1 w-4 h-4 text-safari-green focus:ring-safari-gold rounded"
                  />
                  <span className="text-sm text-gray-700">{service.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Travel Details */}
          <div className="bg-safari-light p-4 rounded-lg">
            <h3 className="text-xl font-bold text-safari-green mb-4">Travel Details</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold mb-2">Preferred Start Date</label>
                <input
                  type="date"
                  name="startDate"
                  value={formData.startDate}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-safari-gold focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2">Preferred End Date</label>
                <input
                  type="date"
                  name="endDate"
                  value={formData.endDate}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-safari-gold focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2">Number of Travelers *</label>
                <input
                  type="number"
                  name="guests"
                  value={formData.guests}
                  onChange={handleChange}
                  min="1"
                  max="50"
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-safari-gold focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2">Accommodation Preference</label>
                <select
                  name="accommodation"
                  value={formData.accommodation}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-safari-gold focus:border-transparent"
                >
                  <option value="">Select preference</option>
                  <option value="budget">Budget (Basic lodges & campsites)</option>
                  <option value="mid-range">Mid-Range (Comfortable lodges)</option>
                  <option value="luxury">Luxury (Premium lodges & camps)</option>
                  <option value="ultra-luxury">Ultra-Luxury (Exclusive properties)</option>
                  <option value="mixed">Mixed (Combination)</option>
                </select>
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-semibold mb-2">Estimated Budget (USD)</label>
                <select
                  name="budget"
                  value={formData.budget}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-safari-gold focus:border-transparent"
                >
                  <option value="">Select budget range</option>
                  <option value="under-2000">Under $2,000 per person</option>
                  <option value="2000-4000">$2,000 - $4,000 per person</option>
                  <option value="4000-6000">$4,000 - $6,000 per person</option>
                  <option value="6000-10000">$6,000 - $10,000 per person</option>
                  <option value="over-10000">Over $10,000 per person</option>
                  <option value="flexible">Flexible</option>
                </select>
              </div>
            </div>
          </div>

          {/* Additional Information */}
          <div>
            <label className="block text-sm font-semibold mb-2">Additional Information & Special Requests</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="5"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-safari-gold focus:border-transparent"
              placeholder="Tell us about your expectations, dietary requirements, physical fitness level, special occasions (honeymoon, anniversary), photography interests, or any other details that will help us create your perfect safari..."
            ></textarea>
          </div>

          {/* Submit Buttons */}
          <div className="flex gap-4 pt-4 border-t border-gray-200">
            <button type="submit" className="btn-primary flex-1 py-4 text-lg">
              Submit Inquiry & Get Custom Quote
            </button>
            <button
              type="button"
              onClick={onClose}
              className="px-8 py-4 border-2 border-gray-300 rounded-lg font-semibold hover:bg-gray-100 transition"
            >
              Cancel
            </button>
          </div>

          <p className="text-xs text-gray-500 text-center">
            By submitting this form, you agree to receive communications from Shakes Travel. We respect your privacy and will never share your information.
          </p>
        </form>
      </div>
    </div>
  )
}
